import { FormlyFieldConfig } from '@ngx-formly/core';
import { AllegatiBolliAltroStep } from '../../shared/allegati-bolli-altro.step';

export const OccupazionePassoCarraioStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.occupazione',
                type: 'mat-input',
                props: {
                    label: 'LARGHEZZA (m)',
                    required: true,
                    type: 'number',
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.distanza_intersezione',
                type: 'mat-input',
                props: {
                    label: 'DISTANZA INTERSEZIONE (m)',
                    required: true,
                    type: 'number',
                    min: 12,
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.distanza_visibilita',
                type: 'mat-input',
                props: {
                    label: 'DISTANZA VISIBILITÀ (m)',
                    required: true,
                    type: 'number',
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1 radio-inline',
                key: 'jd.traffico_opt',
                type: 'mat-radio',
                props: {
                    label: 'FORTE TRAFFICO PEDONALE?',
                    required: true,
                    color: 'primary',
                    options: [
                        { value: 'si', label: 'SI' },
                        { value: 'no', label: 'NO' },
                    ],
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1 radio-inline',
                key: 'jd.rampa_opt',
                type: 'mat-radio',
                props: {
                    label: 'RAMPA CON PENDENZA?',
                    required: true,
                    color: 'primary',
                    options: [
                        { value: 'si', label: 'SI' },
                        { value: 'no', label: 'NO' },
                    ],
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'jd.note_occupazione',
                defaultValue: '',
                type: 'mat-textarea',
                props: {
                    label: 'NOTE',
                    autosize: true,
                    autosizeMaxRows: 8,
                    autosizeMinRows: 2,
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'jd.destinazione_catastale',
                type: 'mat-input',
                props: {
                    label: 'DESTINAZIONE CATASTALE',
                    required: true,
                },
            },
        ],
    },
    ...AllegatiBolliAltroStep
];
